import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVolumeMinComponent } from "./med-icon-volume-min.component";

@NgModule({
  declarations: [
    MedIconVolumeMinComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVolumeMinComponent,
  ],
})
export class MedIconVolumeMinModule { }
